import React from "react";
import ReactPDF, { View, Text, StyleSheet } from "@react-pdf/renderer";
import { colors, typography } from "../config/theme";

const styles = StyleSheet.create({
  root: {
    marginBottom: 2,
  },
  spaceBottom: {
    marginBottom: 10,
  },
});

interface InfoTextProps {
  title: string;
  colored?: boolean; // added green color to title
  spaceBottom?: boolean;
  value: string;
  style?: ReactPDF.Style | ReactPDF.Styles;
}

const InfoText: React.FC<InfoTextProps> = ({
  title,
  value,
  colored = false,
  spaceBottom = false,
  style = [],
}) => {
  const externalStyles = Array.isArray(style) ? style : [style];

  return (
    <View
      style={[
        styles.root,
        spaceBottom ? styles.spaceBottom : {},
        ...externalStyles,
      ]}
    >
      <Text
        style={[typography.defaultBold, colored ? { color: colors.green } : {}]}
      >
        {title} <Text style={typography.default}>{value}</Text>
      </Text>
    </View>
  );
};

export default InfoText;
